module.exports = __webpack_public_path__ + "media/assets/images/smart_working/1-bg-7c862571ad42230e6e9001350cb7b718.jpg";